<div class="c-field__error" *ngIf="visible && errorMessage && currentControl.touched && currentControl.invalid">
  {{ errorMessage | translate }}
</div>
